import { Col, Container, Row } from 'react-bootstrap'
import headerImg from "../Assets/images/hul2.png";
import { useTranslation } from 'react-i18next';
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights';
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection';
import whatYouGetImg from "../Assets/images/wul6.png"
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor';
import img26 from "../Assets/images/5.png";
import img27 from "../Assets/images/3.png";
import img28 from "../Assets/images/11.png";
import img29 from "../Assets/images/4.png";
import img30 from "../Assets/images/6.png";
import img31 from "../Assets/images/7.png";
import img32 from "../Assets/images/10.png";
import manImage from "../Assets/images/Group 126.png";
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup';
import { useState } from 'react';
import { Modal } from 'antd';

const ConversationProgram = () => {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);

    const cardsData = [
        { title: t("duration"), details: t("conversation_programs_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("conversation_programs_cardData.format_details"), img: format },
        { title: t("level"), details: t("conversation_programs_cardData.level_details"), img: level },
        { title: t("certification"), details: t("conversation_programs_cardData.certification_details"), img: certification },
    ];
    
   const whatYouGetData = [
        { description: t("conversation_clubs") },
        { description: t("pronunciation_practice") },
        { description: t("topic_based_dialogue") },
        { description: t("interactive_multimedia") },
        { description: t("regular_feedback") },
    ]
    const whatProgramFor = [
        { img: img26, title: t("students"), desc: t("students_description") },
        { img: img27, title: t("profisionals"), desc: t("beginners_description") },
        { img: img28, title: t("travelars"), desc: t("parents_desc") },
        { img: img29, title: t("outsiders"), desc: t("teachers_desc") },
        { img: img31, title: t("childs"), desc: t("childs_desc") },
        { img: img32, title: t("languagelovers"), desc: t("languagelovers_desc") },
    ];

    return (
        <div className='conversation-program'>
            <section className='arabicLife-sec'>
                <div className='first-section position-relative'>
                    <Row className='justify-content-start flex-column gx-0'>
                        <Col md={12} className='content-box'>
                            <Container>
                                <h2 className='mb-3' style={{ marginTop: "150px" }}>{t("conversation_program")}</h2>
                                <p className='mb-4'>
                                    {t("focused_arabic")}
                                </p>

                            </Container>
                        </Col>

                    </Row>
                    <Row className='justify-content-start flex-column '>
                        <Col md={12} className='green-div'>
                            <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                                <Container>
                                    <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button>
                                </Container>
                            </div>


                        </Col>

                    </Row>
                    <img src={headerImg} alt='' className='ar-life-logo' />
                </div>
            </section>

            <section>
                <Container>
                    <ProgramHighlights cardsData={cardsData} color='#A7D9E659' />
                    <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                </Container>
            </section>

            <section className='my-5'>
                <WhoThisProgramIsFor data={whatProgramFor} />
            </section>
            <section className='my-5'>
                <h2 className="text-center htl-title">{t("tailored_arabic")}</h2>

                <Container>
                    <div className="htl-second-section ">

                        <Row className="align-items-center px-5" >

                            <Col md={7} className="text-section" sm={12}>
                                <h3 className="section-title" style={{ color: "#000000" }}>{t("the_arabic_conversation_program")}</h3>

                                <p className="section-description">
                                    {t("program_description")}
                                </p>
                            </Col>

                            <Col md={5} className="htl-image-section" sm={12}>
                                <img src={manImage} alt="Learning Online" />
                            </Col>

                        </Row>
                    </div>
                </Container>
                <Modal
                    open={isModalOpen}
                    footer={null}
                    destroyOnClose
                    onCancel={() => setIsModalOpen(false)}
                    width={"80vw"}

                >
                    <RegistrationPopup setIsModalOpen={setIsModalOpen} />
                </Modal>
            </section>
        </div>
    )
}

export default ConversationProgram
